import type { RepositoryHttp } from "@/infrastructure/repositories/http";
import type { IRoutes } from "@/types/src/backend/routes";

type Params =
  IRoutes.Endpoints.Expert.Shortlist.Talent.GetSummaryByTalentId["params"];

type Body =
  IRoutes.Endpoints.Expert.Shortlist.Talent.GetSummaryByTalentId["body"];
export class UseCaseShortlistProfileTalentGetSummaryByTalentId {
  constructor(private readonly repository: RepositoryHttp) {}

  public run = async (params: Params, body: Body) => {
    const url: IRoutes.Endpoints.Expert.Shortlist.Talent.GetSummaryByTalentId["url"] =
      `/expert/shortlist/profile/talent/summary/${params.talentId}` as IRoutes.Endpoints.Expert.Shortlist.Talent.GetSummaryByTalentId["url"];

    type Output =
      IRoutes.Endpoints.Expert.Shortlist.Talent.GetSummaryByTalentId["outputData"];

    const result = await this.repository.create<{ jobId: string }, Output>(
      String(url),
      { jobId: body.jobId },
    );

    return result;
  };
}
